/**
 * Function generating years in helper component to datepicker.
 * @param year  - current year (for new absence request) or calendar year (for past absence request).
 * @param offset - number of future years.
 * @returns {array} - collection of dates.
 */
export const getYearRange = (year: string, offset: number) => {
  const currentYear = Number(year);

  const years = [];

  // Push the year before
  years.push((currentYear - 1).toString());

  // Push the given year
  years.push(currentYear.toString());

  // Push the four years after the given year
  // eslint-disable-next-line no-plusplus
  for (let item = 1; item <= offset; item++) {
    years.push((currentYear + item).toString());
  }

  return years;
};
